// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__10-_n","loaderOuter":"PageOverlayLoader_loaderOuter__3wIPy"};